import { format } from 'date-fns';
import dayjs from 'dayjs';

export function QuickSelection({
	setRange,
	onChange
}: {
	setRange: (range: { from: Date; to: Date }) => void;
	onChange: (value: [string | undefined, string | undefined]) => void;
}) {
	return (
		<div className="solid flex flex-col items-start gap-4 border-r pr-4">
			<button
				className="cursor-pointer rounded-md bg-slate-200 px-2 py-1 text-sm font-semibold text-slate-700 select-none"
				type="button"
				onClick={() => {
					const from = dayjs().startOf('month').toDate();
					const to = dayjs().endOf('month').toDate();
					setRange({ from, to });
					onChange([format(from, 'yyyy-MM-dd'), format(to, 'yyyy-MM-dd')]);
				}}
			>
				Ce mois-ci
			</button>
			<button
				onClick={() => {
					const from = dayjs().subtract(1, 'month').startOf('month').toDate();
					const to = dayjs().subtract(1, 'month').endOf('month').toDate();
					setRange({ from, to });
					onChange([format(from, 'yyyy-MM-dd'), format(to, 'yyyy-MM-dd')]);
				}}
				className="cursor-pointer rounded-md bg-slate-200 px-2 py-1 text-sm font-semibold text-slate-700 select-none"
				type="button"
			>
				Le mois dernier
			</button>
			<button
				onClick={() => {
					const from = dayjs().startOf('year').toDate();
					const to = dayjs().endOf('year').toDate();
					setRange({ from, to });
					onChange([format(from, 'yyyy-MM-dd'), format(to, 'yyyy-MM-dd')]);
				}}
				className="cursor-pointer rounded-md bg-slate-200 px-2 py-1 text-sm font-semibold text-slate-700 select-none"
				type="button"
			>
				Cette année
			</button>
			<button
				onClick={() => {
					const from = dayjs().subtract(1, 'year').startOf('year').toDate();
					const to = dayjs().subtract(1, 'year').endOf('year').toDate();
					setRange({ from, to });
					onChange([format(from, 'yyyy-MM-dd'), format(to, 'yyyy-MM-dd')]);
				}}
				className="cursor-pointer rounded-md bg-slate-200 px-2 py-1 text-sm font-semibold text-slate-700 select-none"
				type="button"
			>
				L&apos;année dernière
			</button>
		</div>
	);
}
